import { createApp } from 'vue'
import App from './App.vue'
import { pinia } from './plugins/pinia'
import router from './router'
import i18n from './i18n'
import '@/scss/main.scss'
import { axios } from '@/api'
import './vee-validate'
import VCalendar from 'v-calendar'
import 'v-calendar/style.css'

const app = createApp(App)

// Install plugins
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(VCalendar, {})

// Set global properties
app.config.globalProperties.$api = axios

// Mount the app
app.mount('#app')
